// Shows the booking disclaimer drawer before opening the gappt widget, but only
// for booking links that opt in via `data-booking-disclaimer-trigger` (the
// piercing PDP CTA and the size-guide drawer link). General "book an
// appointment" links elsewhere (nav, stores, ear visualiser) are left alone.
//
// The drawer's "continue" link is a plain #gappt-open link (no trigger
// attribute), so it isn't intercepted and opens the widget as normal.

const TRIGGER = '[data-booking-disclaimer-trigger]'
const CONTINUE_ATTR = 'data-booking-disclaimer-continue'

const drawerWrapper = document.querySelector('[data-booking-disclaimer]')

if (drawerWrapper) {
  const continueLink = drawerWrapper.querySelector(`[${CONTINUE_ATTR}]`)

  // Capture phase so we run before the gappt widget and the global.js handlers,
  // whether they listen via hashchange, delegation, or direct element binding.
  document.addEventListener(
    'click',
    e => {
      const link = e.target.closest(TRIGGER)
      if (!link) return

      e.preventDefault()
      e.stopImmediatePropagation()

      if (continueLink) {
        continueLink.setAttribute(
          'href',
          link.getAttribute('href') || '#gappt-open',
        )
      }

      if (window.drawers) {
        window.drawers.open('booking-disclaimer')
      }
    },
    true,
  )
}
